export const WORKSPACE_REQUEST_DATA = 'WORKSPACE/REQUEST_DATA';
export const WORKSPACE_BEGIN_WRITE_DATA = 'WORKSPACE/BEGIN_WRITE_DATA';
export const WORKSPACE_COMPLETE_WRITE_DATA = 'WORKSPACE/COMPLETE_WRITE_DATA';
export const RECEIVE_WORKSPACES = 'WORKSPACE/RECEIVE_WORKSPACES';
export const SET_ACTIVE_WORKSPACE = 'WORKSPACE/SET_ACTIVE_WORKSPACE';
export const SET_WORKSPACE_ERROR = 'WORKSPACE/SET_WORKSPACE_ERROR';
export const SET_WORKSPACE_USER_COUNT = 'WORKSPACE/SET_WORKSPACE_USER_COUNT';
